import { ReadResult } from 'src/app/models_new/types/rosbag/rosbag-types';
import { RosbagBuffer } from './rosbag-buffer';

/**
 * This function scans all messages in the buffer and checks box release
 * messages for incorrect order, e.g. not GRIPPER -> PALLET BOXES -> GRIPPER.
 * If it finds inconsistencies, it will attempt to analyse and re-order them.
 * @param buffer - The buffer to scan and possibly fix.
 *
 * TODO: This can probably be shortened and optimized a bit, but it works for now.
 */
export function scanIncorrectBoxReleaseMsgOrder(
  buffer: RosbagBuffer,
  searchWindowSize: number = 14
): void {
  // Get all box release message indexes.
  const palletBoxesMsgs = buffer.messages.filter(
    (msg) => msg.topic === '/world/pallet/boxes'
  );
  const indexes = palletBoxesMsgs.map((msg) => msg.bufferIndex);

  // Group the indexes into search groups.
  const searchIndexRanges: number[][] = indexes.map((index) => {
    return [index - searchWindowSize / 2, index + searchWindowSize / 2];
  });

  // Get the messages in the search groups.
  const searchGroupMsgs: ReadResult[][] = searchIndexRanges.map(
    (searchGroup) => {
      return buffer
        .getMessagesByIndex(searchGroup[0], searchGroup[1])
        .filter((msg) => {
          return (
            msg.topic === '/world/pallet/boxes' ||
            msg.topic === '/world/gripper'
          );
        });
    }
  );

  // Simplify orders to easy to compare strings.
  const orders = searchGroupMsgs.map((msgs: ReadResult[]) => {
    return msgs.map((msg: ReadResult) => {
      if (msg.topic === '/world/pallet/boxes') {
        return 'b';
      } else {
        return msg.message.attached_boxes.length > 0 ? 'gt' : 'gc';
      }
    });
  });

  // Correct orders if necessary.
  for (let i = 0; i < orders.length; i++) {
    let first;
    let second;
    // Palleted boxes message comes first.
    if (orders[i][0] === 'b' && orders[i][1] === 'gt') {
      first = searchGroupMsgs[i][0];
      second = searchGroupMsgs[i][1];
    }
    // Palleted boxes message comes last.
    else if (orders[i][1] === 'gc' && orders[i][2] === 'b') {
      first = searchGroupMsgs[i][1];
      second = searchGroupMsgs[i][2];
    }

    if (first && second) {
      // Swap the timestamps to maintain chronological order.
      const temp = first.timestamp;
      first.timestamp = second.timestamp;
      second.timestamp = temp;

      // Swap the messages.
      buffer.setMessageAtIndex(second.bufferIndex, first);
      buffer.setMessageAtIndex(first.bufferIndex, second);
    }
  }
}
